import MultiStepForm from '../../../../../shared/stores/models/MultiStepForm';
import { UserProfileModel } from '../../../../../shared/stores/models/UserProfileModel';
import { DEFAULT } from '../../../../constants/ProductPricingTypes';

import {
  PricingType,
  ProductResponseTypesDTO
} from '../../../dtos/product.dtos';

import { ProductPattern } from '../../Product';

import BaseProduct from '../BaseProduct';

class DefaultProduct extends BaseProduct {
  readonly pricingType: PricingType = DEFAULT;
  productPrice!: number;
  constructor(
    productObject: ProductResponseTypesDTO,
    userProfileDetails: UserProfileModel | null
  ) {
    super(productObject);

    this.productPrice = productObject.productDetails.productPrice;
    this.form = new MultiStepForm(
      productObject.formFieldStepConfig.registration_form_details,
      userProfileDetails
    );
  }

  match<T>(p: ProductPattern<T>): T {
    return p.DefaultProduct(this);
  }
}

export default DefaultProduct;
